/**
 * tween.js v24 stopped registering a `new Tween(target)` with the shared
 * default group automatically; a tween now needs an explicit group before
 * the render loop's `TWEEN.update()` call will drive it. Passing `true` as
 * the constructor's second argument is tween.js's own documented shortcut
 * for restoring that legacy default-group behavior, without every call site
 * managing its own `Group` instance.
 *
 * The library's source marks this `true` overload as "will be removed in
 * future release", so treat every use of this constant as a placeholder for
 * an eventual move to explicit `Group` instances, not a permanent pattern.
 */
export const USE_LEGACY_TWEEN_GROUP = true as const;
